import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'DITEC — Digital Intelligence & Technology Excellence Council';

export default function SEO({ title, description, image, path, type = 'website' }) {
  const base = window.location.origin;
  const fullTitle = title ? `${title} | DITEC` : SITE_NAME;
  const desc = description || 'A connected digital capability ecosystem for students, enterprises and institutions.';
  const img = image ? (image.startsWith('http') ? image : `${base}${image}`) : `${base}/assets/og-default.png`;
  const url = `${base}${path || window.location.pathname}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content="DITEC" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
